"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoTileWasRemovedHandler = videoTileWasRemovedHandler;
exports.videoTileWasRemovedHandlerForMixer = videoTileWasRemovedHandlerForMixer;
var _logger = require("@studio/logger");
var _constants = require("../../../constants");
function videoTileWasRemovedHandler(meetingResponse, attendeeResponse) {
  return function videoTileWasRemovedHandler(tileId) {
    var meetingId = meetingResponse.Meeting.MeetingId;
    var attendeeId = attendeeResponse.Attendee.AttendeeId;
    var logPayload = {
      chimeEventName: 'videoTileWasRemoved',
      'tile-id': tileId,
      'studio.meeting.id': meetingId,
      title: "Tile id: ".concat(tileId, " removed from meeting id: ").concat(meetingId, " by attendee ").concat(attendeeId)
    };
    (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
  };
}
function videoTileWasRemovedHandlerForMixer(meetingResponse, attendeeResponse, meetingSession, setAttendeeCameraStatus, attendeeCameraStatusHandler, dispatch) {
  return function videoTileWasRemovedHandler(tileId) {
    var meetingId = meetingResponse.Meeting.MeetingId;
    var attendeeId = attendeeResponse.Attendee.AttendeeId;
    var logPayload = {
      chimeEventName: 'videoTileWasRemoved',
      'tile-id': tileId,
      'studio.meeting.id': meetingId,
      title: "Tile id: ".concat(tileId, " removed from meeting id: ").concat(meetingId, " by attendee ").concat(attendeeId)
    };
    (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
    attendeeCameraStatusHandler(meetingSession, dispatch, setAttendeeCameraStatus);
  };
}